import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { App, Flex } from 'antd';

import { useCreateBotMutation, useReadBotQuery } from '../service/bot';
import { Save } from '../../../widgets/Save';
import { useApiErrorNotification } from '../../../../../hooks/useApiErrorNotification';
import { MainForm } from '../components/MainForm';
import { MainBotInfo } from '../components/MainBotInfo';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const MainContainer = () => {
    const current = useAppSelector(selectShopCurrent);
    const { notification } = App.useApp();

    const [
        createBot,
        {
            isError,
            error,
            isSuccess: isSucceeCreate,
            isLoading: isLoadingCreate,
        },
    ] = useCreateBotMutation();

    const { data, isSuccess, refetch, isLoading } = useReadBotQuery(current.id);

    useApiErrorNotification(isError, error);

    useEffect(() => {
        if (isSuccess && data) {
            formik.setValues({ ...data });
        }
    }, [isSuccess, data]);

    useEffect(() => {
        if (isSucceeCreate) {
            notification.success({
                message: 'Сохранено',
            });
            refetch();
        }
    }, [isSucceeCreate]);

    const onSave = () => {
        const data = {
            ...formik.values,
            shop_id: current.id,
        };

        createBot(data);
    };

    const formik = useFormik({
        initialValues: {
            token: '',
        },
        onSubmit: onSave,
    });

    return (
        <>
            <Flex
                vertical
                gap={24}
                style={{
                    width: '283px',
                }}
            >
                <MainForm loading={isLoading} formik={formik} />
                {data && <MainBotInfo data={data} />}
            </Flex>

            <Save
                onSave={onSave}
                disabled={isLoadingCreate}
                loading={isLoadingCreate}
            />
        </>
    );
};
